
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hot-deal/[slug]",
      function () {
        return require("private-next-pages/hot-deal/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hot-deal/[slug]"])
      });
    }
  